module.exports = "/assets/2205c60cc1bc05983e0e5a99bfeb1125.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LC.png
// module id = 2698
// module chunks = 0